import React from 'react';
import { connect } from 'react-redux';
import { Nav } from "react-bootstrap";
import config from '../../config';

import {stringify} from 'qs';


import getMessage from "../../utils/getMessage";
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router';

const LanguageSwitcher = () => {
  const location = useLocation();

  const getChangedLanguagePath = (location, nextLang) => {
    const languageParam = stringify({lang: nextLang});
    let searchParams;
    if (location.search.includes('lang=')) {
      searchParams = location.search.replace(/lang=\w{2}/, languageParam);
    } else if (location.search) {
      searchParams = location.search + `&${languageParam}`;
    } else {
      searchParams = `?${languageParam}`
    }

    return {
      pathname: location.pathname,
      search: searchParams || languageParam,
    }
  }

  const newLanguage = () => {
    const languageIndex = config.languages.findIndex((lang) => (lang == config.activeLanguage));
    const nextLanguage = config.languages[ (languageIndex+1) % config.languages.length ];
    return nextLanguage;
  }
  return (
    <LinkContainer to={getChangedLanguagePath(location, newLanguage())}>
      <Nav.Link
        aria-label={getMessage(`lang-${newLanguage()}`)}
        lang={newLanguage()}
        className="language-button nav-item nav-link"
        href="#"
      >
      <span className="language-title" lang={newLanguage()}>{getMessage(`lang-${newLanguage()}`)}</span>
      </Nav.Link>
    </LinkContainer>
  );
}

export { LanguageSwitcher as UnconnectedLanguageSwitcher};
export default connect()(LanguageSwitcher);
